import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core'
import { UntypedFormBuilder, Validators } from '@angular/forms'
import { BaseError, HttpError } from '../../../../utils/errors'
import { ErrorResponse } from '../../../services/dtos'
import { isTopmostModal, popModal, pushModal } from 'src/app/shared/modal-dialog/modal-key-stack'

@Component({
  selector: 'confirm-action-dialog',
  templateUrl: './confirm-action-dialog.component.html',
  styleUrls: ['./confirm-action-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ConfirmActionDialogComponent implements OnInit, OnDestroy {
  @Input() name: string
  @Input() action: string = 'Delete'
  @Input() error: string
  @Input() busy: boolean = false
  @Output() onAction = new EventEmitter<null>()
  @Output() onCancel = new EventEmitter<null>()

  confirmActionFormModel = this.formBuilder.group({
    confirmation: ['', [Validators.pattern(/\s*i\s+understand\s*/i), Validators.required]],
  })

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    pushModal(this)
  }

  ngOnDestroy() {
    popModal(this)
  }

  // Esc = Cancel. Document-level so it fires regardless of focus position
  // inside the modal. Short-circuits while `busy` so an accidental Esc can't
  // tear down the dialog mid-request. Topmost-modal gate prevents stacked
  // dialogs (e.g. this dialog over a launch-test) from both dismissing on
  // a single Esc press.
  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKeydown(event: KeyboardEvent): void {
    if (!isTopmostModal(this)) return
    if (this.busy) return
    event.preventDefault()
    this.onCancelClick()
  }

  onActionClick() {
    this.onAction.emit(null)
  }

  onCancelClick() {
    this.onCancel.emit(null)
  }

  get actionEnabled() {
    return this.confirmActionFormModel.valid
  }

  get actionButtonText() {
    return this.action.toUpperCase()
  }
}
